// Temporary gate on /finance's money tabs (To do to Business expenses) and their
// drawers, recorded as the exception in
// docs/design-decisions/DD-040-finance-open-to-every-admin.md. Every admin sees
// the Finance nav entry, /finance's Price list and a client's Finance tab (the
// user 2026-10-30). Only the tabs hide; routes and the API stay open.
export const FINANCE_TABS_EMAIL = "octavianrotari@beenerdy.co";

const LOCAL_HOSTS = ["localhost", "127.0.0.1"];

export function canSeeFinanceTabs(
  email: string | null | undefined,
  hostname: string = window.location.hostname,
): boolean {
  if (LOCAL_HOSTS.includes(hostname)) return true;
  return !!email && email.toLowerCase() === FINANCE_TABS_EMAIL;
}
